import React from 'react';
type CardProps = {
  children: React.ReactNode;
  className?: string;
};
export const Card: React.FC<CardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`bg-white rounded-xl shadow-sm p-4 sm:p-5 border border-gray-100 ${className}`} data-id="element-312">
      {children}
    </div>;
};